module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-9-2ba3e8010f4197eb717ecc7247ec3d62.svg";